import clsx from 'clsx';
import { Variant } from 'components/CruiseSearchWidget/types';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { LeftArrowIcon } from 'components/Icon/Icon';
import { BasicButton } from 'components/buttons/BasicButton/BasicButton';
import { useAppContext } from 'contexts/appContext';
import { useMedia } from 'hooks/useMedia';
import { sizes } from 'styles/sizes';
import { CloseModalButton } from '../CloseModalButton/CloseModalButton';
import styles from './ActiveFilterHeader.css';
interface ActiveFilterHeaderProps {
	selectionCount: number;
	variant: Variant;
}

export function ActiveFilterHeader({ selectionCount, variant }: Readonly<ActiveFilterHeaderProps>) {
	const { activeFilter, setActiveFilter } = useFiltersContext();

	const isDesktop = useMedia(`(min-width: ${sizes.desktop}px)`);
	const { dictionary } = useAppContext();

	if (!activeFilter) return;

	const { [activeFilter.dictionaryModalLabel ?? activeFilter.dictionaryLabel]: filterLabel, actionAllFilters: allFiltersLabel } = dictionary;

	return (
		<header className={clsx(styles.root, { [styles.selected]: selectionCount > 0 })}>
			<div className={styles.navigation}>
				{!isDesktop && variant === Variant.Base && (
					<BasicButton
						testId="mobile-all-filters-header-button"
						label={allFiltersLabel}
						onClick={() => setActiveFilter(null)}
						variant="text"
						icon={LeftArrowIcon}
					/>
				)}
				<span className={styles.title}>{filterLabel}</span>
				<CloseModalButton testId="close-filter-modal-button" rootClass={!isDesktop ? styles.closeButton : ''} iconClass={styles.closeIcon} />
			</div>
			{!isDesktop && <span className={styles.title}>{filterLabel}</span>}
		</header>
	);
}
